import { render, staticRenderFns } from "./demandDetail.vue?vue&type=template&id=80951290&scoped=true"
import script from "./demandDetail.vue?vue&type=script&lang=js"
export * from "./demandDetail.vue?vue&type=script&lang=js"
import style0 from "./demandDetail.vue?vue&type=style&index=0&id=80951290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80951290",
  null
  
)

export default component.exports